module.exports = __webpack_public_path__ + "img/arrow.01cf66b2.svg";